import Snappy from '../../../libs/snappy/snappy';

Snappy.Component.InputField = class InputField extends Snappy.BaseComponent {
	static get tagName() {
		return 'fa-input-field';
	}
	
	constructor(element) {
		super(element);
	}
	
	render() {
	}
};



// WEBPACK FOOTER //
// ./components/inputField/scripts/inputField.js